import { render } from "./EditCreate.vue?vue&type=template&id=0c1315a2&scoped=true&ts=true"
import script from "./EditCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCreate.vue?vue&type=script&lang=ts&setup=true"

import "./EditCreate.vue?vue&type=style&index=0&id=0c1315a2&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1315a2"],['__file',"resources/js/Pages/Orchard/IrrigationWaterData/EditCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c1315a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c1315a2', __exports__)) {
    console.log('reload')
    api.reload('0c1315a2', __exports__)
  }
  
  module.hot.accept("./EditCreate.vue?vue&type=template&id=0c1315a2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0c1315a2', render)
  })

}


export default __exports__